import { AsarFormikInput, AsarFormikSelect } from "@/components";
import { Grid, useMediaQuery } from "@mui/material";
import { bloodTypes } from "../../../utils";

export default function GeneralInfo() {
  const md = useMediaQuery("(max-width:450px)");
  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        sx={{ width: "100%" }}
        alignItems={"center"}
        gap={"10px"}
      >
        <AsarFormikInput
          name={"abilities"}
          label={"مهارت ها"}
          multiline
          placeholder="در چه زمینه‌هایی مهارت دارید؟"
        />

        <AsarFormikInput
          label={"بیماری ها"}
          name={"diseases"}
          multiline
          placeholder="آیا بیماری خاصی دارید؟"
        />
        <AsarFormikInput
          label={"حساسیت ها"}
          name={"allergies"}
          multiline
          placeholder="آیا حساسیت خاصی دارید؟"
        />
        <AsarFormikSelect
          label={"گروه خونی"}
          name={"bloodType"}
          width={"100%"}
          data={bloodTypes}
          placeholder="گروه خونی خود را انتخاب کنید."
        />
      </Grid>
    </>
  );
}
